import { jsx as _jsx } from "react/jsx-runtime";
import { useContext } from 'react';
import { ThemeContext } from 'styled-components';
export function ArrowRightIcon(props) {
    const themeContext = useContext(ThemeContext);
    const { color = 'Grey6', ...rest } = props;
    const primaryFillColor = themeContext.colors[color];
    return (_jsx("svg", { width: "1em", height: "1em", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...rest, children: _jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M7 20V4l12 8-12 8z", fill: primaryFillColor }) }));
}
//# sourceMappingURL=ArrowRight.js.map